/**
 * WebGPU API Detector
 * Critical for detecting headless browsers (SwiftShader, ANGLE)
 */

export interface WebGPUResult {
  available: boolean;
  adapter?: string;
}

interface GPU {
  requestAdapter(): Promise<GPUAdapter | null>;
}

interface GPUAdapter {
  info?: {
    vendor?: string;
    architecture?: string;
    device?: string;
    description?: string;
  };
}

export async function detectWebGPU(): Promise<WebGPUResult> {
  try {
    const gpu = (navigator as Navigator & { gpu?: GPU }).gpu;

    if (!gpu) {
      return { available: false };
    }

    const adapter = await gpu.requestAdapter();

    if (!adapter) {
      return { available: true };
    }

    // Get adapter info (vendor, architecture, etc.)
    const info = adapter.info;
    const adapterStr = info
      ? [info.vendor, info.architecture, info.device, info.description]
          .filter(Boolean)
          .join(' ')
      : undefined;

    return {
      available: true,
      adapter: adapterStr,
    };
  } catch (error) {
    return { available: false };
  }
}
